const OrganizationEntity = (backClient) => ({
  index: async () => {
    const { data } = await backClient.get(`/api/organizations`)
    return data
  },
  getChildOrganizations: async () =>
    await backClient.get(`/api/organizations?without_current`),
  getParentOrganization: async () =>
    await backClient.get("/api/parent_organization"),

  getCurrentOrganization: async (
    filters = {},
    treeSort = {},
    { reload = false } = {}
  ) => {
    const params = {}

    if (reload) {
      params.reload = "true"
    }

    // filter parameters
    if (filters.scored !== undefined) {
      params.scored_nodes = filters.scored.toString()
    }
    if (filters.open !== undefined) {
      params.open_nodes = filters.open.toString()
    }
    if (filters.guests !== undefined) {
      params.nodes_with_guests = filters.guests.toString()
    }
    if (filters.search) {
      params.search = filters.search
    }
    if (filters.selectedNodeIds && filters.selectedNodeIds.length > 0) {
      params.selected_node_ids = filters.selectedNodeIds
    }

    // sort parameters to map frontend names to backend expected names
    if (treeSort.field && treeSort.direction) {
      params.sort_field = treeSort.field
      params.sort_direction = treeSort.direction
    }

    return await backClient.get("/api/tree", { params })
  },

  getReassessmentAvailable: async () =>
    await backClient.get(`/api/organizations/reassessment/available`),
  postReassessment: async (reassessmentBody) =>
    await backClient.post(`/api/organizations/reassessment`, reassessmentBody),
  postSubscription: async () =>
    await backClient.post(`/api/organizations/subscription`),
  getHistory: async () => await backClient.get(`/api/organizations/histories`),
  getCurrentPeriod: async () =>
    await backClient.get("/api/organizations/histories/current_period"),
  putHistory: async (companyId) =>
    await backClient.put(`/api/organizations/histories/${companyId}`),
  getNavigationOrganizations: async () => {
    const { data } = await backClient.get("/api/navigation_organizations")
    return data
  },
})

export default OrganizationEntity
